import { render, staticRenderFns } from "./createBModel.vue?vue&type=template&id=54a1bbca&scoped=true"
import script from "./createBModel.vue?vue&type=script&lang=js"
export * from "./createBModel.vue?vue&type=script&lang=js"
import style0 from "./createBModel.vue?vue&type=style&index=0&id=54a1bbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1bbca",
  null
  
)

export default component.exports